import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import TrackingRepositoriesFactory from '../Repositories/factory.js'

class RegisterCsatNpsVisitTrackingUseCase extends UseCase {
  #config
  #repository

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new RegisterCsatNpsVisitTrackingUseCase({
      config,
      repository: TrackingRepositoriesFactory.sessionStorageCsatNpsRepository({config})
    })
  }

  @tracer({metric: 'RegisterCsatNpsVisitTrackingUseCase#execute'})
  @AsyncInlineError()
  async execute({adId} = {}) {
    const {MIN_VISITED_ADS} = this.#config.get('COMMON').CSAT_NPS
    const storedState = await this.#repository.getState()

    if (storedState.isTriggered) return {state: storedState, isEligible: false}

    const hasAdId = adId !== undefined && adId !== null && adId !== ''
    const id = hasAdId ? String(adId) : undefined
    const {hasVisitedList, visitedAdIds} = storedState

    const shouldMarkList = !hasAdId && !hasVisitedList
    const shouldAddAdId = hasAdId && visitedAdIds.length < MIN_VISITED_ADS && !visitedAdIds.includes(id)

    const state = {
      ...storedState,
      hasVisitedList: hasVisitedList || shouldMarkList,
      visitedAdIds: shouldAddAdId ? [...visitedAdIds, id] : visitedAdIds
    }

    if (shouldMarkList || shouldAddAdId) await this.#repository.saveState({state})

    const isEligible = state.hasVisitedList && state.visitedAdIds.length >= MIN_VISITED_ADS

    return {state, isEligible}
  }
}

export const factory = RegisterCsatNpsVisitTrackingUseCase.create
